import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter-sharp",
  "use": "icon-filter-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-filter-sharp\"><title>Filter</title><path d=\"M16 120h480v48H16zM96 232h320v48H96zM192 344h128v48H192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol